import { Icons } from '@/components/icons';
import {
  defaultEnumFilter,
  defaultNumberFilter,
  defaultRelationFilter,
  defaultSelectFilter,
  defaultStringFilter,
  type Filter,
} from '@/components/table-filters/constants';
import {
  ParkingLotConfig,
  ParkingSpotConfig,
  TenantConfig,
} from '@pigello/pigello-matrix';
import baseRevenueIncreaseFilters from '../contracts/components/base-revenue-increase-filters';
import baseFilters, {
  baseAddressFilters,
  baseBuildingFilter,
  baseGlobalRealEstatesFilter,
  baseSpaceFutureContractingFilters,
  baseSpaceStatusFilters,
  baseTagFilter,
} from '../filters';
import { isFeatureEnabled } from '@/hooks/use-feature-flag';
import { FEATURE_FLAGS } from '@/hooks/use-feature-flag/constants';

const parkingSpotFilters: Filter[] = [
  ...baseSpaceStatusFilters,
  ...baseSpaceFutureContractingFilters,
  ...baseBuildingFilter,
  ...baseGlobalRealEstatesFilter,
  {
    ...defaultRelationFilter,
    title: ParkingSpotConfig.fields.parkingLot.verboseName,
    externalFieldName: ParkingSpotConfig.fields.parkingLot.externalFieldName,
    relationModelName: ParkingLotConfig.modelName,
    icon: Icons.parkinglot,
  },
  {
    ...defaultSelectFilter,
    title: ParkingSpotConfig.fields.category.verboseName,
    externalFieldName: ParkingSpotConfig.fields.category.externalFieldName,
    choices: ParkingSpotConfig.fields.category.choices,
  },
  {
    ...defaultStringFilter,
    title: ParkingSpotConfig.fields.popularName.verboseName,
    externalFieldName: ParkingSpotConfig.fields.popularName.externalFieldName,
  },
  {
    ...defaultStringFilter,
    title: ParkingSpotConfig.fields.landlordCustomId.verboseName,
    externalFieldName:
      ParkingSpotConfig.fields.landlordCustomId.externalFieldName,
    icon: Icons.id,
  },
  {
    ...defaultStringFilter,
    title: ParkingSpotConfig.fields.customId.verboseName,
    externalFieldName: ParkingSpotConfig.fields.customId.externalFieldName,
  },
  {
    ...defaultNumberFilter,
    title: ParkingSpotConfig.fields.usableArea.verboseName,
    externalFieldName: ParkingSpotConfig.fields.usableArea.externalFieldName,
  },
  {
    ...defaultNumberFilter,
    title: ParkingSpotConfig.fields.biArea.verboseName,
    externalFieldName: ParkingSpotConfig.fields.biArea.externalFieldName,
  },

  {
    ...defaultRelationFilter,
    title: ParkingSpotConfig.fields.tenant.verboseName,
    externalFieldName: ParkingSpotConfig.fields.tenant.externalFieldName,
    relationModelName: TenantConfig.modelName,
    icon: Icons.tenant,
  },
  {
    ...defaultRelationFilter,
    title: ParkingSpotConfig.fields.biTenants.verboseName,
    externalFieldName: ParkingSpotConfig.fields.biTenants.externalFieldName,
    relationModelName: TenantConfig.modelName,
    icon: Icons.tenant,
  },
  ...(isFeatureEnabled(FEATURE_FLAGS.MARKET)
    ? [
        {
          ...defaultEnumFilter,
          title: 'Annonser',
          externalFieldName: 'custom_space_check_active_listing',
          enumChoices: [
            {
              title: 'Aktiv/kommande annons',
              badgeVariant: 'green' as const,
              filters: [
                { operator: 'noop' as const, value: 'has_active_listing' },
              ],
            },
            {
              title: 'Saknar aktiv/kommande annons',
              badgeVariant: 'destructive' as const,
              filters: [
                { operator: 'noop' as const, value: 'no_active_listing' },
              ],
            },
          ],
        },
      ]
    : []),

  ...baseRevenueIncreaseFilters,
  ...baseAddressFilters,
  ...baseTagFilter,
  ...baseFilters,
];

export default parkingSpotFilters;
